import React from "react";
import styled from "styled-components";

const Card = styled.div`
  border-radius: 8px;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);
  margin: 24px 6px 32px 6px;
`;

const RecipeContent = styled.div`
  padding: 12px 4px;
`;

const RecipeImg = styled.div`
	background-image: url(${(props) => props.thumbnailUrl});
	background-position: center;
  background-size: cover;
	border-top-left-radius: 8px;
	border-top-right-radius: 8px;
	width: 100%;
	height: 140px;
`;

const RecipeName = styled.div`
  text-align: center;
  font-size: 1.25rem;
  font-weight: 600;
`;

const RecipeServings = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  p {
    color: #808080;
    font-size: 0.8rem;
    margin: 6px 4px;
  }
`;

const SectionLabel = styled.h6`
  color: #65666f;
  font-size: 0.8rem;
  padding-left: 8px;
  text-transform: uppercase;
`;

const RecipeIngredients = styled.div`
  margin-left: 8px;
`;

const Instructions = styled.div`
  padding: 16px;
  p {
    font-size: 0.9rem;
    letter-spacing: 0px;
	white-space: pre-wrap;
  }
`;

const Ingredient = ({
  item,
}) => {
  return (
    <div className="tracker-search-item">
      <div className="data-container">
        <div className="data">
          <p className="name">{item.name}</p>
          <p className="unit">
            {item.serving} {item.unit}
          </p>
        </div>
      </div>
    </div>
  );
};

export const RecipeCard = ({item}) => {
  if (item) {
    return (
      <Card>
        {(item.thumbnailUrl || item.bannerUrl) && <RecipeImg thumbnailUrl={item.bannerUrl || item.thumbnailUrl} />}
        <RecipeContent>
          <RecipeName>{item.name}</RecipeName>
          <RecipeServings>
            {item.baseGrams > 0 ? (
              <>
                <p>
                  1 serving: {Math.round(item.baseGrams / item.baseServing)}g
                </p>
                <p>Yields: {item.baseServing} servings</p>
              </>
            ) : (
              <p>Yields: {item.baseServing} servings</p>
            )}
          </RecipeServings>
          <SectionLabel>Ingredients</SectionLabel>
          <RecipeIngredients>
            {item.foods.map((ingredient, index) => (
              <Ingredient
                item={ingredient}
                key={index}
              />
            ))}
          </RecipeIngredients>
          <SectionLabel>Instructions</SectionLabel>
          <Instructions>
            <p>{item.instructions}</p>
          </Instructions>
        </RecipeContent>
      </Card>
    );
  } else {
    return <></>;
  }
};
